var _path, _g, _path2, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJetpack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 338,
    height: 360,
    x: 71,
    y: 60,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M391.762 133.398A31.323 31.323 0 0 1 409 161.375v157.279a31.323 31.323 0 0 1-17.243 27.98L254.08 415.915a31.325 31.325 0 0 1-28.16 0L88.243 346.634A31.323 31.323 0 0 1 71 318.654V161.376a31.323 31.323 0 0 1 17.238-27.978L225.916 64.09a31.322 31.322 0 0 1 28.168 0l137.678 69.308Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "m408.573 140.944-168.151 85.49-.5 196.051 153.115-76.709a28.14 28.14 0 0 0 15.536-25.16V140.944Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "m398.193 145.713-161.892 81.466v188.397l146.401-73.67a28.142 28.142 0 0 0 15.491-25.138V145.713Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M227.319 62.892a28.142 28.142 0 0 1 25.204 0l156.049 78.154-168.651 85.258L71.27 141.046l156.049-78.154Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5DD17C",
    d: "M227.44 71.385a28.14 28.14 0 0 1 25.119 0l134.747 67.203-147.307 74.157-147.307-74.157L227.44 71.385Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.999 140.944 240 226.246v196.67L86.49 345.668A28.142 28.142 0 0 1 71 320.53V140.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "m71.27 140.944 169.151 85.49v196.55l-153.645-77.2a28.142 28.142 0 0 1-15.507-25.146V140.944Z",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M313.181 163.458a45.027 45.027 0 0 1 24.781 40.218v58.05a45.027 45.027 0 0 1-24.787 40.221l-52.934 26.637a45.02 45.02 0 0 1-40.479 0l-52.934-26.637a45.025 45.025 0 0 1-24.787-40.221v-58.05a45.026 45.026 0 0 1 24.78-40.218l52.934-26.647a45.023 45.023 0 0 1 40.492 0l52.934 26.647Z",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#202124",
    d: "M240.001 333.366V226.23l-91.4-45.993a44.832 44.832 0 0 0-6.56 23.356v58.203c0 16.969 9.58 32.492 24.768 40.136l52.893 26.616a45.145 45.145 0 0 0 20.299 4.818Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 132,
    height: 137,
    x: 174,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F4EA",
    d: "M292.801 188.695a22.513 22.513 0 0 1 12.391 20.109v47.814a22.512 22.512 0 0 1-12.394 20.11l-42.677 21.476a22.511 22.511 0 0 1-20.24 0l-42.678-21.476a22.513 22.513 0 0 1-12.393-20.11v-47.814a22.512 22.512 0 0 1 12.39-20.109l42.678-21.485a22.518 22.518 0 0 1 20.246 0l42.677 21.485Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6F4EA",
    d: "M292.801 188.695a22.513 22.513 0 0 1 12.391 20.109v47.814a22.512 22.512 0 0 1-12.394 20.11l-42.677 21.476a22.511 22.511 0 0 1-20.24 0l-42.678-21.476a22.513 22.513 0 0 1-12.393-20.11v-47.814a22.512 22.512 0 0 1 12.39-20.109l42.678-21.485a22.518 22.518 0 0 1 20.246 0l42.677 21.485Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m70.692 140.016 169.001 85.044v196.67l-153.51-77.247a28.142 28.142 0 0 1-15.491-25.139V140.016Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M409.002 139.277 240.001 224.32v196.671l153.509-77.248a28.141 28.141 0 0 0 15.492-25.139V139.277Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 193.215,
    height: 301.186,
    x: 220.64,
    y: 130.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_350_4458",
    stdDeviation: 7.831
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 310.275,
    height: 159.98,
    x: 84.862,
    y: 60.596,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_350_4458",
    stdDeviation: 3.915
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 200.324,
    height: 313.037,
    x: 55.031,
    y: 124.355,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_350_4458",
    stdDeviation: 7.831
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 200.324,
    height: 313.036,
    x: 224.34,
    y: 123.615,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_350_4458",
    stdDeviation: 7.831
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetpack);
export default __webpack_public_path__ + "static/media/jetpack.7113d4c05762025f697592278959c942.svg";
export { ForwardRef as ReactComponent };